var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"picto-info-comment mdi mdi-comment-processing",class:{ actif: _vm.value },attrs:{"title":_vm.value || _vm.$t('poster.table.renderers.comment_attribute.no_comment')}})
}
var staticRenderFns = []

export { render, staticRenderFns }